/* Sara Sakina launch product page: swipeable arch gallery, scroll reveals, the notes journey
   (the bottle turns with the scroll and the colour deepens from top to base notes). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = root => {
    if (root.dataset.lpReady) return;
    root.dataset.lpReady = 'true';
    root.classList.add('is-js');

    // Gallery
    const track = root.querySelector('[data-lp-track]');
    const slides = Array.from(root.querySelectorAll('[data-lp-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-lp-go]'));
    const prev = root.querySelector('[data-lp-prev]');
    const next = root.querySelector('[data-lp-next]');
    const stageBottle = root.querySelector('.ss-lp__bottle');
    let index = 0;
    const go = (target, smooth = true) => {
      if (!track || !slides.length) return;
      const to = Math.max(0, Math.min(slides.length - 1, target));
      track.scrollTo({ left: to * track.clientWidth, behavior: smooth && !reduce.matches ? 'smooth' : 'auto' });
    };
    const sync = () => {
      if (!track) return;
      const current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (current === index) return;
      index = current;
      thumbs.forEach(thumb => thumb.setAttribute('aria-current', Number(thumb.dataset.lpGo) === index ? 'true' : 'false'));
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= slides.length - 1;
      const active = thumbs.find(thumb => Number(thumb.dataset.lpGo) === index);
      if (active && active.parentElement) {
        const strip = active.parentElement;
        const left = active.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2;
        strip.scrollTo({ left, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      if (index === 0 && stageBottle && stageBottle.spin) stageBottle.spin(true);
    };
    if (track) {
      let queued = false;
      track.addEventListener('scroll', () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; sync(); });
      }, { passive: true });
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1); }
      });
    }
    thumbs.forEach(thumb => thumb.addEventListener('click', () => go(Number(thumb.dataset.lpGo))));
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    if (next) next.disabled = slides.length < 2;
    root.addEventListener('sf:variant-updated', event => {
      const media = event.detail && event.detail.variant && event.detail.variant.media;
      if (!media) return;
      const target = slides.findIndex(slide => slide.dataset.lpMedia === String(media));
      if (target > -1) go(target);
    });

    // Reveals
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      reveal.unobserve(entry.target);
    }), { rootMargin: '0px 0px -12% 0px' });
    root.querySelectorAll('[data-lp-reveal], [data-lp-chapter]').forEach(element => reveal.observe(element));

    // Notes journey
    const journey = root.querySelector('[data-lp-journey]');
    if (!journey) return;
    const chapters = Array.from(journey.querySelectorAll('[data-lp-chapter]'));
    const sets = Array.from(journey.querySelectorAll('[data-lp-set]'));
    const rails = Array.from(journey.querySelectorAll('[data-lp-rail]'));
    const scrub = journey.querySelector('.ss-lp__scrub');
    const setChapter = number => {
      if (journey.dataset.chapter === String(number)) return;
      journey.dataset.chapter = String(number);
      sets.forEach((set, i) => set.classList.toggle('is-on', i === number));
      rails.forEach((rail, i) => rail.classList.toggle('is-on', i === number));
    };
    const chapterObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) setChapter(Number(entry.target.dataset.lpChapter) || 0);
    }), { rootMargin: '-45% 0px -45% 0px' });
    chapters.forEach(chapter => chapterObserver.observe(chapter));

    let ticking = false;
    const update = () => {
      ticking = false;
      const box = journey.getBoundingClientRect();
      const travel = Math.max(1, box.height - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -box.top / travel));
      journey.style.setProperty('--lp-p', progress.toFixed(4));
      if (scrub && scrub.setAngle) scrub.setAngle(progress * 360);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll();
      } else {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }).observe(journey);
  };

  const boot = () => document.querySelectorAll('.ss-lp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();